<template>
  <div id="container">
    <div class="product-status">
      <div class="bold"></div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          class="tab-text"
          v-for="(item, index) in acceptDraftManageList"
          :key="index"
        ></el-tab-pane>
      </el-tabs>
          <finance-seach
            :column-option="nobillList"
            ref="clearSeachInfo"
            :expression-array="['billMoney','day']"
            @onSearch="getList"
            :timer-array="['billDate','billEnddate','createDate']"
          >
            <div class="search_rightitem" v-show="activeName === '1'">
              <el-form-item>
                <el-button type="primary" @click="addbill()">添加汇票</el-button>
              </el-form-item>
            </div>
          </finance-seach>

          <div class="box-table" :style="{height: financeTableHeight + 'px'}">
            <el-row style="margin-bottom:20px;">
              <el-col :span="4">
                查询结果共：
                <span style="color:#D35E5E">{{ total }}<span style="color:#4e555b">
                  条</span></span>
              </el-col>

              <el-col :span="8" v-if="activeName === '1'">
                汇票可使用金额：
                <span style="color:#D35E5E;">{{ totalPrice | showPrice }}<span style="color:#4e555b">
                  元</span></span>
              </el-col>
              <el-col :span="8" v-else>
                已使用总金额：
                <span style="color:#D35E5E;">{{ totalPrice | showPrice }}<span style="color:#4e555b">
                  元</span></span>
              </el-col>
            </el-row>
            <el-table
              border
              ref="tableRef"
              :data="list"
              :max-height="financeTableHeight-40"
              tooltip-effect="dark"
              :header-cell-style="tableHeader"
              v-loading="loadingTable"
              element-loading-text="拼命加载中请稍后..."
              element-loading-spinner="el-icon-loading"
              :default-sort="{prop: 'createDate',order:'descending'}"
            >
              <el-table-column prop="billNumber" label="汇票票号" :key="1"></el-table-column>
              <el-table-column prop="billMoney" label="票据金额" :key="2">
                <template v-slot="{row}">{{row.billMoney | toFixed}}</template>
              </el-table-column>
              <el-table-column label="出票单位" width="110" prop="billCompany" :key="3"></el-table-column>
              <el-table-column prop="billBank" label="出票行" width="110" :key="4"></el-table-column>
              <el-table-column prop="billDate" label="出票日期" width="100" :key="5">
                <template slot-scope="scope">
                  {{
                  scope.row.billDate | dateFilterD
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="billEnddate" label="到期日期" width="140" :key="6">
                <template slot-scope="scope">
                  {{
                  scope.row.billEnddate | dateFilterD
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="billDays" label="期限" :key="7"></el-table-column>
              <el-table-column prop="day" v-if="activeName === '1'" label="到期天数" :key="8"></el-table-column>
              <el-table-column prop="cbName" label="使用对象" v-if="activeName === '2'" :key="9">
                <template v-slot="{ row }">
                  <el-link
                    :underline="false"
                    type="primary"
                    @click="goCustomerDetail(row)"
                  >{{row.cbName || '--'}}</el-link>
                </template>
              </el-table-column>
              <el-table-column label="状态" v-if="activeName === '1'"  :key="10">
                <template slot-scope="scope">
                  <span>{{ scope.row.billState | billState }}</span>
                </template>
              </el-table-column>
              <el-table-column label="状态" v-else  :key="11">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    style="color:#606266!important; "
                    @click="lookBtn(scope.row)"
                  >{{ scope.row.billState | billState }}
                  </el-button>
                </template>
              </el-table-column>

              <el-table-column prop="fromType" label="来源"  :key="12">
                <template slot-scope="scope">
                  <span>{{ scope.row.fromType | fromType }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="createUser" label="添加人" width="100" :key="13"></el-table-column>
              <el-table-column
                prop="createDate"
                label="添加日期"
                :key="14"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate | dateFilter }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="billEnddate"
                label="更新日期"
                width="100"
                :key="15"
                v-if="activeName !== '1'"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.processDate | dateFilter }}</span>
                </template>
              </el-table-column>

              <el-table-column
                label="操作"
                prop="billState"
                :key="16"
                v-if="activeName === '1'"
                width="100"
              >
                <template slot-scope="scope">
                  <el-button type="text" @click="lookBtn(scope.row)">查看</el-button>
                  <el-button
                    :disabled="scope.row.esbillState"
                    type="text"
                    @click="addload(scope.row)"
                    v-if="scope.row.fromType === 1"
                  >作废
                  </el-button>
                  <el-button
                    type="text"
                    @click="discount(scope.row)"
                    :disabled="scope.row.isBillState"
                    v-else
                  >贴现
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="操作" v-else  :key="17">
                <template slot-scope="scope">
                  <el-button type="text" @click="lookBtn(scope.row)">查看</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 弹框=================================================================================================== -->
          <el-dialog title="贴现确认" :visible.sync="dialogFormVisibledis" width="720px" append-to-body>
            <span class="bill" style="padding-left: 38px;">确定已贴现该汇票？</span>
            <el-form :model="bankformListobj">
              <el-form-item label="承兑票号：" style="padding-top:20px" :label-width="formLabelWidth">
                {{bankformListobj.billNumber}}
              </el-form-item>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="贴现银行："
                    :label-width="formLabelWidth"
                    :rules="[{ required: true, message: '不能为空' }]"
                  >
                    <el-input v-model="bankformListobj.billDiscountBank" placeholder="请填写贴现银行名称"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="贴现日期："
                    :label-width="formLabelWidth"
                    :rules="[{ required: true, message: '不能为空' }]"
                  >
                    <el-date-picker
                      v-model="bankformListobj.billDiscountDate"
                      type="date"
                      style="width: 100%"
                      placeholder="选择日期："
                    >{{ bankformListobj.billDiscountDate }}
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="票据金额：" :label-width="formLabelWidth">
                    <el-input disabled v-model="priceNum"></el-input>
                  </el-form-item>
                  <!-- {{showPrice(bankformListobj.billMoney)}} -->
                </el-col>
                <el-col :span="12">
                  <el-form-item label="实际到账金额：" :label-width="formLabelWidth">
                    <el-input
                      v-model="bankformListobj.billDiscountMoneyReal"
                      autocomplete="off"
                      oninput="value=value.replace(/[^0-9.]/g,'')"
                      placeholder="请填写实际到账金额"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-form-item label="贴现备注：" :label-width="formLabelWidth">
                <el-input maxlength="150" show-word-limit type="textarea" v-model="bankformListobj.billDiscountMark"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer">
              <el-button type="primary" @click="surebill">确 定</el-button>
              <el-button @click="dialogFormVisibledis = false">取 消</el-button>
            </div>
          </el-dialog>
          <!-- 作废的弹框 -->
          <el-dialog title="作废确认" :visible.sync="dialogFormVisible" append-to-body width="720px">
            <el-form :model="bankformListobj" style="color:#D35E5E;padding:0 50px">
              <span style="padding-top:5px">确定作废该汇票?</span>
              <el-form-item
                style="padding-top:30px"
                prop="billDiscountMark"
                label="作废备注："
                :rules="[{ required: true, message: '不能为空' }]"
              >
                <el-input
                  v-model.trim="bankformListobj.billDiscountMark"
                  style="width:85%"
                  :autosize="{minRows:6,maxRows:6}"
                  type="textarea"
                  maxlength="150"
                  how-word-limit
                  placeholder="请填写作废备注"
                ></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer">
              <el-button type="primary" @click="sureBtn">确 定</el-button>
              <el-button @click="dialogFormVisible = false">取 消</el-button>
            </div>
          </el-dialog>
          <!-- 修改后弹出框 -->

          <div class="pagination">
            <pagination
              :total="total"
              @handleCurrentChange="handleCurrentChange"
              @handleSizeChange="handleSizeChange"
            ></pagination>
          </div>

    </div>
  </div>
</template>
<script>
import { expressionList } from '@/components/utils/data'
import pagination from '@/components/pagination'
import { formatDate } from '@/util/tool'
import {
  acceptDraftManageList,
  usedbillList,
  nobillList
} from '../financeManage/util/data'
import {
  queryAcceptanceBillListByStatebill,
  updateById
} from '@/api/fiance/fianceManage'

import financeSeach from '@/components/module/financeSeach'
import { mapState } from 'vuex'

export default {
  components: {
    pagination: pagination,
    financeSeach
  },

  data () {
    return {
      miState: '2',
      activeName: '', // tabs选中状态
      acceptDraftManageList: acceptDraftManageList, // tabs状态
      loadingTable: false, // 列表loading
      list: [], // 列表数据
      mark: '',
      totalPrice: 0, // 总价
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0, // 列表总数
      queryParams: {}, // 搜索条件
      params: {},
      usedbillList: usedbillList, // 筛选条件
      nobillList: nobillList, // 不可用的筛选
      expressionList: expressionList,
      checked: false,
      bankformListobj: {},
      dialogFormVisible: false,
      dialogFormVisibledis: false,
      time: [],
      billEnddate: '',
      formLabelWidth: '110px',
      preParams: '',
      priceNum: '' // 贴现金额精确后面两位小数
    }
  },
  computed: {
    ...mapState(['financeTableHeight'])
  },
  watch: {
    activeName (newval) {
      if (newval === '1') {
        this.nobillList = [...nobillList, {
          label: '到期天数',
          value: 'day'
        }]
      } else {
        this.nobillList = [...nobillList, {
          label: '使用对象',
          value: 'cbName'
        }]
      }
      return newval
    }
  },
  mounted () {
    this.activeName = '1'
    this.getList()
  },
  filters: {
    dateFilterTwo,
    dateFilter (time) {
      const date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:ss')
    },
    showPrice (totalPrice) {
      if (!totalPrice) return 0
      return totalPrice && totalPrice.toFixed(2)
    },
    billState (billState) {
      if (billState === 1) {
        return '未使用'
      } else if (billState === 2) {
        return '已使用'
      } else if (billState === 3) {
        return '已贴现'
      } else if (billState === 4) {
        return '已作废'
      }
    },
    fromType (fromType) {
      if (fromType === 1) {
        return '后台添加'
      } else if (fromType === 2 || fromType === 3) {
        return '收款申请'
      }
      return '--'
    }
  },
  methods: {
    goCustomerDetail (row) {
      if (!row.cbName) return
      // this.$router.push({ name: 'customer/details', query: { id: id } })
      this.$router.push({ name: 'supplierEdit', query: { id: row.cbId } })
    },
    // 重置
    searchReset () {
      this.params = {}
      this.queryParams = {}
      this.getList()
    },
    // 搜索
    onSearch () {
      if (this.time && this.time.length === 2) {
        this.params.value = this.time[0]
        this.params.endValue = this.time[1]
      }
      if (this.params.value === '' || this.params.value === undefined) {
        this.$message.error('搜索条件不能为空')
      } else {
        this.getList()
      }
    },
    // 作废
    addload (row) {
      this.bankformListobj = row
      this.dialogFormVisible = true
    },
    // 贴现
    discount (row) {
      this.priceNum = this.$options.filters.showPrice(row.billMoney)
      this.bankformListobj = row
      this.dialogFormVisibledis = true
    },
    // 贴现弹框确认
    surebill () {
      if (
        !this.bankformListobj.billDiscountDate ||
          !this.bankformListobj.billDiscountBank
      ) {
        this.$message.error('必填项不能为空，请检查！！')
        return
      }
      const paramss = {
        billState: 3,
        id: this.bankformListobj.id,
        billDiscountMark: this.bankformListobj.billDiscountMark,
        billDiscountBank: this.bankformListobj.billDiscountBank,
        billDiscountDate: this.bankformListobj.billDiscountDate,
        priceNum: this.priceNum,
        billDiscountMoneyReal: this.bankformListobj.billDiscountMoneyReal
      }
      updateById(paramss, 'updateByIdDiscount')
        .then((res) => {
          if (res.data.code === 200) {
            this.$message({
              message: '贴现成功！！',
              type: 'success'
            })
            this.list.forEach((ele) => {
              if (ele.id === this.bankformListobj.id) {
                ele.isBillState = true
              }
            })
            this.dialogFormVisibledis = false
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 添加汇票
    addbill () {
      this.$router.push({
        name: 'addbill'
      })
    },
    sureBtn () {
      // 作废
      const paramss = {
        billState: 4,
        id: this.bankformListobj.id,
        billDiscountMark: this.bankformListobj.billDiscountMark
      }
      if (!this.bankformListobj.billDiscountMark) {
        this.$message.error('必填项不能为空，请检查！！')
        return
      }

      updateById(paramss)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message({
              message: '提交成功！！',
              type: 'success'
            })
            this.list.forEach((ele) => {
              if (ele.id === this.bankformListobj.id) {
                ele.esbillState = true
              }
            })
            this.handleClick({
              name: '1'
            })
            this.dialogFormVisible = false
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 查看
    lookBtn (row) {
      this.bankformListobj.billDiscountMark = ''
      this.$router.push({
        name: 'acceplist',
        query: { type: 2, fprsId: row.id, billState: row.billState }
      })
    },
    // tabs切换时触发的事件
    handleClick (tab) {
      this.currentPage = 1
      this.activeName = tab.name
      this.$refs.clearSeachInfo.innerInit()
      this.getList()
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 列表数据
    getList (list) {
      this.loadingTable = true
      if (this.activeName === '1') {
        this.miState = 1
      } else {
        this.miState = 2
      }
      const params = {
        criteriaVoList: list || this.preParams || [],
        queryPageName: ''
      }
      if (list) {
        this.currentPage = 1
      }
      queryAcceptanceBillListByStatebill(
        this.miState,
        this.currentPage,
        this.pageSize,
        params
      )
        .then((res) => {
          if (res.data.code === 200) {
            this.preParams = list
            this.loadingTable = false
            this.totalPrice = res.data.obj.records[0] && res.data.obj.records[0].money
            res.data.obj.records[0] && res.data.obj.records[0].financeAcceptanceBillList.forEach((ele) => {
              // this.totalPrice += ele.billMoney
              ele.isBillState = false
              ele.esbillState = false
            })
            this.list = res.data.obj.records[0] && res.data.obj.records[0].financeAcceptanceBillList
            this.total = res.data.obj.total
          }
        })
        .catch((err) => {
          console.log(err)
        })
      this.queryParams = {}
      this.params = {}
    },
    // 页数
    handleSizeChange (val) {
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    }
  }
}
function dateFilterTwo (time) {
  const date = new Date(time)
  return formatDate(date, 'yyyy-MM-dd')
}

</script>
<style lang="less" scoped>
  .bill {
    color: #d35e5e;
    padding-left: 55px;
  }
</style>
